/**
 * Copyright © Binary Anvil, Inc. All rights reserved.
 * See https://binaryanvil.com/software/license for license details.
 */
import {useMemo} from "react";
import jsonToJsx from "@/app/utils/jsonToJsx";
import {useEffect} from "react";
import {TCmsPageData} from "@/app/types/prefetchedData/cmsPageData";

/**
 * Connector for getting CMS page data
 */
const useProcessCmsPage = (data:TCmsPageData | null) => {
    const cmsPage = data?.cmsPageData;

    const cmsPageContent = useMemo(() => {
        if (!cmsPage) {
            return <></>;
        }

        const json = cmsPage.content_json ?? cmsPage.content ?? '{}';

        return jsonToJsx(json);
    }, [cmsPage]);

    useEffect(() => {
        if (data && data.errorMessage) {
            console.log(data.errorMessage);
        }
    },[]);

    return {cmsPageContent, cmsPage};
}

export default useProcessCmsPage;